(function () {
  const root = document.getElementById("pk-special-order");
  if (!root) return;

  const API_BASE = (root.dataset.apiBase || "").replace(/\/$/, "");
  let requestId = null;
  let selectedCardRef = null;
  let allOffers = [];
  let activeGradeFilter = "ALL";
  const $ = (sel) => root.querySelector(sel);

  const GRADE_FILTER_ORDER = [
    "ALL",
    "PSA10",
    "PSA9",
    "PSA8",
    "PSA8以下",
    "A",
    "B",
    "C",
    "D",
    "ARS10",
    "ARS9",
    "BGS10",
    "新品",
    "OTHER",
  ];

  const GRADE_FILTER_LABELS = {
    ALL: "Tous",
    PSA10: "PSA 10",
    PSA9: "PSA 9",
    PSA8: "PSA 8",
    "PSA8以下": "PSA 8 et moins",
    A: "Grade A",
    B: "Grade B",
    C: "Grade C",
    D: "Grade D",
    ARS10: "ARS 10",
    ARS9: "ARS 9",
    BGS10: "BGS 10",
    新品: "Neuf",
    OTHER: "Autre",
  };

  const lightbox = document.querySelector("[data-lightbox]");
  const lightboxImg = lightbox?.querySelector("[data-lightbox-img]");
  const lightboxCaption = lightbox?.querySelector("[data-lightbox-caption]");
  const lightboxViewport = lightbox?.querySelector("[data-lightbox-viewport]");
  const lightboxCounter = lightbox?.querySelector("[data-lightbox-counter]");
  const lightboxThumbs = lightbox?.querySelector("[data-lightbox-thumbs]");
  const lightboxPrev = lightbox?.querySelector("[data-lightbox-prev]");
  const lightboxNext = lightbox?.querySelector("[data-lightbox-next]");
  const zoomLabel = lightbox?.querySelector("[data-zoom-label]");
  let lightboxScale = 1;
  let galleryUrls = [];
  let galleryIndex = 0;
  let galleryTitle = "";
  const ZOOM_MIN = 1;
  const ZOOM_MAX = 3;
  const ZOOM_STEP = 0.25;

  const STEPS = ["search", "candidates", "offers", "checkout"];
  const stepIndex = (name) => STEPS.indexOf(name);

  function updateStepper(activeStep) {
    const idx = stepIndex(activeStep);
    root.querySelectorAll("[data-stepper-item]").forEach((el) => {
      const i = stepIndex(el.dataset.stepperItem);
      el.classList.toggle("is-active", i === idx);
      el.classList.toggle("is-done", i >= 0 && i < idx);
    });
  }

  function showStep(name) {
    root.querySelectorAll("[data-step]").forEach((el) => {
      el.hidden = el.dataset.step !== name;
    });
    updateStepper(name);
    const formWrap = root.querySelector(".pk-special-order__form-wrap");
    if (formWrap && name !== "search") {
      formWrap.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  function productThumbHtml(imgUrl, alt, title, fallbackUrl) {
    const src = String(imgUrl || "").trim();
    const fallback = String(fallbackUrl || "").trim();
    if (!src && !fallback) {
      return `<figure class="pk-special-order__thumb pk-special-order__thumb--empty" aria-hidden="true">
        <div class="pk-special-order__thumb-btn pk-special-order__thumb-btn--placeholder">Pas de photo</div>
      </figure>`;
    }
    const displaySrc = src || fallback;
    const safeSrc = escapeHtml(displaySrc);
    const safeFallback = fallback && fallback !== displaySrc ? escapeHtml(fallback) : "";
    const safeAlt = escapeHtml(alt || "Photo produit");
    const safeTitle = escapeHtml(title || alt || "Photo produit");
    const onerr = safeFallback
      ? ` onerror="if(this.dataset.fallback){this.src=this.dataset.fallback;this.dataset.fallback=''}" data-fallback="${safeFallback}"`
      : ` onerror="this.closest('.pk-special-order__thumb-btn')?.classList.add('is-broken')"`;
    return `<figure class="pk-special-order__thumb">
      <button type="button" class="pk-special-order__thumb-btn" data-zoom-open data-zoom-src="${safeSrc}" data-zoom-alt="${safeAlt}" data-zoom-title="${safeTitle}" aria-label="Agrandir : ${safeTitle}">
        <img src="${safeSrc}" alt="${safeAlt}" loading="lazy" width="140" height="196"${onerr}/>
      </button>
      <span class="pk-special-order__thumb-hint">Agrandir la photo</span>
    </figure>`;
  }

  function applyLightboxZoom() {
    if (!lightboxImg) return;
    lightboxImg.style.transform = `scale(${lightboxScale})`;
    if (zoomLabel) zoomLabel.textContent = `${Math.round(lightboxScale * 100)} %`;
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    lightbox.setAttribute("aria-hidden", "true");
    document.body.classList.remove("pk-so-lightbox-open");
    lightboxScale = 1;
    applyLightboxZoom();
    if (lightboxImg) lightboxImg.src = "";
  }

  function normalizeImageUrls(offer, fallback) {
    const raw = Array.isArray(offer?.imageUrls) ? offer.imageUrls : [];
    const list = raw.filter((u) => typeof u === "string" && u.trim());
    if (list.length) return [...new Set(list)];
    const one = offer?.imageUrl || fallback;
    return one ? [String(one)] : [];
  }

  function offerPhotosHtml(images, title) {
    if (!images.length) {
      return `<div class="pk-special-order__photos pk-special-order__photos--empty">Pas de photo</div>`;
    }
    const safeTitle = escapeHtml(title);
    const json = escapeHtml(JSON.stringify(images));
    const thumbs =
      images.length > 1
        ? `<div class="pk-special-order__photos-thumbs" role="list">${images
            .map(
              (url, i) =>
                `<button type="button" class="pk-special-order__photo-thumb${i === 0 ? " is-active" : ""}" data-photo-pick data-photo-index="${i}" aria-label="Photo ${i + 1}">
            <img src="${escapeHtml(url)}" alt="" loading="lazy" width="64" height="90"/>
          </button>`,
            )
            .join("")}</div>`
        : "";
    return `
      <div class="pk-special-order__photos" data-offer-photos data-images="${json}" data-active-index="0" data-zoom-title="${safeTitle}">
        <div class="pk-special-order__photos-main">
          <button type="button" class="pk-special-order__photos-main-btn" data-zoom-main aria-label="Voir en grand : ${safeTitle}">
            <img src="${escapeHtml(images[0])}" alt="${safeTitle}" loading="lazy" data-offer-main-img/>
          </button>
          <span class="pk-special-order__photo-count">${images.length} photo${images.length > 1 ? "s" : ""} · clic pour zoomer</span>
        </div>
        ${thumbs}
      </div>`;
  }

  function setOfferMainPhoto(wrap, urls, index) {
    if (!wrap || !urls[index]) return;
    wrap.dataset.activeIndex = String(index);
    const main = wrap.querySelector("[data-offer-main-img]");
    if (main) main.src = urls[index];
    wrap.querySelectorAll("[data-photo-pick]").forEach((btn) => {
      btn.classList.toggle(
        "is-active",
        parseInt(btn.dataset.photoIndex, 10) === index,
      );
    });
  }

  function renderLightboxGalleryUi() {
    const multi = galleryUrls.length > 1;
    if (lightboxPrev) lightboxPrev.hidden = !multi;
    if (lightboxNext) lightboxNext.hidden = !multi;
    if (lightboxCounter) {
      lightboxCounter.hidden = !multi;
      lightboxCounter.textContent = multi
        ? `Photo ${galleryIndex + 1} / ${galleryUrls.length}`
        : "";
    }
    if (!lightboxThumbs) return;
    if (!multi) {
      lightboxThumbs.hidden = true;
      lightboxThumbs.innerHTML = "";
      return;
    }
    lightboxThumbs.hidden = false;
    lightboxThumbs.innerHTML = galleryUrls
      .map(
        (url, i) =>
          `<button type="button" class="pk-so-lightbox__thumb${i === galleryIndex ? " is-active" : ""}" data-lightbox-thumb="${i}">
        <img src="${escapeHtml(url)}" alt="" loading="lazy"/>
      </button>`,
      )
      .join("");
    lightboxThumbs.querySelectorAll("[data-lightbox-thumb]").forEach((btn) => {
      btn.addEventListener("click", () => {
        galleryIndex = parseInt(btn.dataset.lightboxThumb, 10) || 0;
        showLightboxSlide();
      });
    });
  }

  function showLightboxSlide() {
    if (!lightbox || !lightboxImg) return;
    const src = galleryUrls[galleryIndex];
    if (!src) return;
    lightboxScale = 1;
    lightbox.classList.add("is-loading");
    lightboxImg.onload = () => lightbox.classList.remove("is-loading");
    lightboxImg.onerror = () => {
      lightbox.classList.remove("is-loading");
      if (lightboxCaption) lightboxCaption.textContent = "Image indisponible";
    };
    lightboxImg.src = src;
    lightboxImg.alt = galleryTitle || "Photo produit";
    if (lightboxCaption) lightboxCaption.textContent = galleryTitle;
    applyLightboxZoom();
    renderLightboxGalleryUi();
    if (lightboxViewport) {
      lightboxViewport.scrollTop = 0;
      lightboxViewport.scrollLeft = 0;
    }
  }

  function openLightbox(src, alt, title) {
    galleryUrls = src ? [src] : [];
    galleryIndex = 0;
    galleryTitle = title || alt || "Photo produit";
    if (!galleryUrls.length) return;
    lightbox.hidden = false;
    lightbox.setAttribute("aria-hidden", "false");
    document.body.classList.add("pk-so-lightbox-open");
    showLightboxSlide();
    lightbox.querySelector("[data-lightbox-close]")?.focus();
  }

  function openLightboxGallery(urls, index, title) {
    galleryUrls = (urls || []).filter(Boolean);
    if (!galleryUrls.length) return;
    galleryIndex = Math.max(0, Math.min(index, galleryUrls.length - 1));
    galleryTitle = title || "Photo produit";
    lightbox.hidden = false;
    lightbox.setAttribute("aria-hidden", "false");
    document.body.classList.add("pk-so-lightbox-open");
    showLightboxSlide();
    lightbox.querySelector("[data-lightbox-close]")?.focus();
  }

  function galleryStep(delta) {
    if (galleryUrls.length < 2) return;
    galleryIndex = (galleryIndex + delta + galleryUrls.length) % galleryUrls.length;
    showLightboxSlide();
  }

  function bindZoomTriggers(scope) {
    (scope || root).querySelectorAll("[data-zoom-open]").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        openLightbox(
          btn.dataset.zoomSrc,
          btn.dataset.zoomAlt,
          btn.dataset.zoomTitle,
        );
      });
    });
  }

  function bindOfferPhotoControls(li) {
    const wrap = li.querySelector("[data-offer-photos]");
    if (!wrap) return;
    let urls = [];
    try {
      urls = JSON.parse(wrap.dataset.images || "[]");
    } catch {
      urls = [];
    }
    const title = wrap.dataset.zoomTitle || "Photo annonce";

    wrap.querySelectorAll("[data-photo-pick]").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        const idx = parseInt(btn.dataset.photoIndex, 10) || 0;
        setOfferMainPhoto(wrap, urls, idx);
      });
    });

    wrap.querySelector("[data-zoom-main]")?.addEventListener("click", (e) => {
      e.stopPropagation();
      const idx = parseInt(wrap.dataset.activeIndex || "0", 10) || 0;
      if (urls.length) openLightboxGallery(urls, idx, title);
    });
  }

  function initLightbox() {
    if (!lightbox) return;
    lightbox.querySelectorAll("[data-lightbox-close]").forEach((el) => {
      el.addEventListener("click", closeLightbox);
    });
    lightboxPrev?.addEventListener("click", () => galleryStep(-1));
    lightboxNext?.addEventListener("click", () => galleryStep(1));
    lightbox.querySelector("[data-zoom-in]")?.addEventListener("click", () => {
      lightboxScale = Math.min(ZOOM_MAX, lightboxScale + ZOOM_STEP);
      applyLightboxZoom();
    });
    lightbox.querySelector("[data-zoom-out]")?.addEventListener("click", () => {
      lightboxScale = Math.max(ZOOM_MIN, lightboxScale - ZOOM_STEP);
      applyLightboxZoom();
    });
    lightbox.querySelector("[data-zoom-reset]")?.addEventListener("click", () => {
      lightboxScale = 1;
      applyLightboxZoom();
      if (lightboxViewport) {
        lightboxViewport.scrollTop = 0;
        lightboxViewport.scrollLeft = 0;
      }
    });
    document.addEventListener("keydown", (e) => {
      if (lightbox.hidden) return;
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowLeft") galleryStep(-1);
      if (e.key === "ArrowRight") galleryStep(1);
      if (e.key === "+" || e.key === "=") {
        lightboxScale = Math.min(ZOOM_MAX, lightboxScale + ZOOM_STEP);
        applyLightboxZoom();
      }
      if (e.key === "-") {
        lightboxScale = Math.max(ZOOM_MIN, lightboxScale - ZOOM_STEP);
        applyLightboxZoom();
      }
    });
    lightboxViewport?.addEventListener(
      "wheel",
      (e) => {
        if (lightbox.hidden) return;
        e.preventDefault();
        const delta = e.deltaY < 0 ? ZOOM_STEP : -ZOOM_STEP;
        lightboxScale = Math.min(
          ZOOM_MAX,
          Math.max(ZOOM_MIN, lightboxScale + delta),
        );
        applyLightboxZoom();
      },
      { passive: false },
    );
  }

  function showError(msg) {
    const el = $("[data-error]");
    if (!el) return;
    if (msg) {
      el.textContent = msg;
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  }

  function apiNetworkErrorHint() {
    if (!API_BASE) {
      return "URL API non configurée dans la section Shopify (réglage « URL API sourcing »).";
    }
    return (
      "Connexion à l’API impossible (réseau, CORS ou serveur). " +
      "Vérifiez l’URL : " +
      API_BASE +
      " — puis redéployez l’API (git pull + pm2 restart)."
    );
  }

  async function api(path, options = {}) {
    let res;
    try {
      res = await fetch(`${API_BASE}${path}`, {
        ...options,
        headers: {
          "Content-Type": "application/json",
          ...(options.headers || {}),
        },
      });
    } catch {
      throw new Error(apiNetworkErrorHint());
    }
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.ok === false) {
      const hint = data.message || `Erreur HTTP ${res.status}`;
      throw new Error(hint);
    }
    return data;
  }

  async function compressImageForUpload(file, maxBytes = 1_400_000) {
    if (!file.type?.startsWith("image/")) {
      throw new Error("Fichier image invalide.");
    }
    const bitmap = await createImageBitmap(file);
    let w = bitmap.width;
    let h = bitmap.height;
    const maxDim = 1600;
    if (w > maxDim || h > maxDim) {
      const ratio = Math.min(maxDim / w, maxDim / h);
      w = Math.round(w * ratio);
      h = Math.round(h * ratio);
    }
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("Impossible de traiter l’image.");
    ctx.drawImage(bitmap, 0, 0, w, h);
    bitmap.close?.();

    let quality = 0.88;
    let blob = await new Promise((resolve) =>
      canvas.toBlob(resolve, "image/jpeg", quality),
    );
    while (blob && blob.size > maxBytes && quality > 0.45) {
      quality -= 0.08;
      blob = await new Promise((resolve) =>
        canvas.toBlob(resolve, "image/jpeg", quality),
      );
    }
    if (!blob) throw new Error("Impossible de compresser l’image.");
    const name = (file.name || "photo").replace(/\.[^.]+$/, "") + ".jpg";
    return new File([blob], name, { type: "image/jpeg" });
  }

  function readImageAsBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result;
        if (typeof result !== "string" || !result.includes(",")) {
          reject(new Error("Impossible de lire l’image."));
          return;
        }
        resolve({
          base64: result.split(",")[1],
          mime: file.type || "image/jpeg",
        });
      };
      reader.onerror = () => reject(new Error("Impossible de lire l’image."));
      reader.readAsDataURL(file);
    });
  }

  const notFoundForm = $("[data-card-not-found-form]");
  const candidatesMain = $("[data-candidates-main]");
  const notFoundSuccess = $("[data-not-found-success]");
  const candidatesBack = $("[data-candidates-back]");
  let nfImagePreviewUrl = null;

  function getSearchFieldValues() {
    const searchForm = $("[data-search-form]");
    if (!searchForm) return {};
    return {
      setCode: String(searchForm.querySelector('[name="setCode"]')?.value || "").trim(),
      cardNumber: String(searchForm.querySelector('[name="cardNumber"]')?.value || "").trim(),
      title: String(searchForm.querySelector('[name="title"]')?.value || "").trim(),
      language: String(searchForm.querySelector('[name="language"]')?.value || "JP").trim(),
    };
  }

  function prefillNotFoundForm(reason = "no_match") {
    if (!notFoundForm) return;
    const ref = selectedCardRef || getSearchFieldValues();
    const setEl = notFoundForm.querySelector('[name="nfSetCode"]');
    const numEl = notFoundForm.querySelector('[name="nfCardNumber"]');
    const titleEl = notFoundForm.querySelector('[name="nfTitle"]');
    const langEl = notFoundForm.querySelector('[name="nfLanguage"]');
    if (setEl) setEl.value = ref.setCode || "";
    if (numEl) numEl.value = ref.cardNumber || "";
    if (titleEl) {
      titleEl.value =
        ref.titleFR || ref.titleJP || ref.title || titleEl.value || "";
    }
    if (langEl) langEl.value = ref.language === "FR" ? "FR" : "JP";

    const emailEl = notFoundForm.querySelector('[name="nfCustomerEmail"]');
    if (emailEl && !emailEl.value && window.Shopify?.customer?.email) {
      emailEl.value = window.Shopify.customer.email;
    }
    const nameEl = notFoundForm.querySelector('[name="nfCustomerName"]');
    if (nameEl && !nameEl.value) {
      const c = window.Shopify?.customer;
      const full = [c?.first_name, c?.last_name].filter(Boolean).join(" ").trim();
      if (full) nameEl.value = full;
    }

    const reasonEl = notFoundForm.querySelector("[data-nf-reason]");
    if (reasonEl) reasonEl.value = reason;

    syncNotFoundGradeField();
  }

  function syncNotFoundGradeField() {
    const gradeWrap = $("[data-nf-grade-field]");
    if (!gradeWrap || !notFoundForm) return;
    const productType =
      notFoundForm.querySelector('[name="nfProductType"]:checked')?.value || "";
    const show = productType === "graded";
    gradeWrap.hidden = !show;
  }

  function setNotFoundFormVisible(show, reason = "no_match") {
    if (!notFoundForm) return;
    if (show) {
      prefillNotFoundForm(reason);
      notFoundForm.hidden = false;
      if (candidatesMain) candidatesMain.hidden = true;
      if (candidatesBack) candidatesBack.hidden = true;
      if (notFoundSuccess) notFoundSuccess.hidden = true;
      const hint = $("[data-candidates-hint]");
      if (hint) hint.hidden = true;
    } else {
      notFoundForm.hidden = true;
      if (candidatesMain) candidatesMain.hidden = false;
      if (candidatesBack) candidatesBack.hidden = false;
      if (notFoundSuccess) notFoundSuccess.hidden = true;
      const hint = $("[data-candidates-hint]");
      if (hint) hint.hidden = false;
    }
    showError("");
  }

  function showNotFoundSuccess(message) {
    if (notFoundForm) notFoundForm.hidden = true;
    if (candidatesMain) candidatesMain.hidden = true;
    if (candidatesBack) candidatesBack.hidden = true;
    if (notFoundSuccess) {
      notFoundSuccess.hidden = false;
      const msgEl = notFoundSuccess.querySelector("[data-not-found-success-msg]");
      if (msgEl && message) msgEl.textContent = message;
    }
    const hint = $("[data-candidates-hint]");
    if (hint) hint.hidden = true;
  }

  function updateNotFoundFileLabel(file) {
    const nameEl = $("[data-nf-file-name]");
    const preview = $("[data-nf-image-preview]");
    if (nfImagePreviewUrl) {
      URL.revokeObjectURL(nfImagePreviewUrl);
      nfImagePreviewUrl = null;
    }
    if (!file) {
      if (nameEl) nameEl.textContent = "Aucun fichier";
      if (preview) {
        preview.hidden = true;
        preview.innerHTML = "";
      }
      return;
    }
    if (nameEl) nameEl.textContent = file.name;
    if (preview) {
      nfImagePreviewUrl = URL.createObjectURL(file);
      preview.innerHTML = `<img src="${nfImagePreviewUrl}" alt="Aperçu" loading="lazy" />`;
      preview.hidden = false;
    }
  }

  async function init() {
    if (!API_BASE) {
      showError(
        "URL API non configurée. Renseignez « URL API sourcing » dans les réglages de la section Shopify.",
      );
      return;
    }
    try {
      await api("/status");
    } catch (err) {
      showError(
        (err instanceof Error ? err.message : null) ||
          "Le service de commande spéciale est temporairement indisponible.",
      );
    }
  }

  root.querySelectorAll("[data-back]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const target = btn.getAttribute("data-back");
      if (target) showStep(target);
      showError("");
      if (target === "search" || target === "candidates") {
        setNotFoundFormVisible(false);
        if (notFoundSuccess) notFoundSuccess.hidden = true;
      }
    });
  });

  async function handleSearch() {
    const searchForm = $("[data-search-form]");
    if (!searchForm) return;

    const setCode = String(
      searchForm.querySelector('[name="setCode"]')?.value || "",
    ).trim();
    const cardNumber = String(
      searchForm.querySelector('[name="cardNumber"]')?.value || "",
    ).trim();
    const title = String(
      searchForm.querySelector('[name="title"]')?.value || "",
    ).trim();
    const language = String(
      searchForm.querySelector('[name="language"]')?.value || "JP",
    ).trim();

    if (!setCode || !cardNumber) {
      showError("Indiquez le code série et le numéro de carte.");
      searchForm.querySelector('[name="setCode"]')?.focus();
      return;
    }

    showError("");
    const body = {
      setCode,
      cardNumber,
      title: title || undefined,
      language,
    };
    const submitBtn = searchForm.querySelector("[data-search-submit]");
    if (submitBtn) submitBtn.disabled = true;
    try {
      const data = await api("/search", {
        method: "POST",
        body: JSON.stringify(body),
      });
      requestId = data.requestId;
      selectedCardRef = {
        setCode: body.setCode,
        cardNumber: body.cardNumber,
        language: body.language,
      };
      const candidates = data.candidates || [];
      renderCandidates(candidates);
      showStep("candidates");
      if (!candidates.length) {
        setNotFoundFormVisible(true, "no_match");
        showError(
          "Aucune carte trouvée pour cette recherche. Complétez le formulaire ci-dessous avec une photo.",
        );
        return;
      }
      setNotFoundFormVisible(false);
    } catch (err) {
      showError(err.message);
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  }

  const searchForm = $("[data-search-form]");
  searchForm?.addEventListener("submit", (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleSearch();
  });
  searchForm
    ?.querySelector("[data-search-submit]")
    ?.addEventListener("click", (e) => {
      e.preventDefault();
      handleSearch();
    });
  searchForm?.querySelectorAll("input, select").forEach((el) => {
    el.addEventListener("keydown", (e) => {
      if (e.key !== "Enter") return;
      e.preventDefault();
      handleSearch();
    });
  });

  function renderCandidates(list) {
    const ul = $("[data-candidates-list]");
    if (!ul) return;
    ul.innerHTML = "";
    list.forEach((c) => {
      const li = document.createElement("li");
      li.className = "pk-special-order__candidate";
      const title = c.titleFR || c.titleJP || `${c.setCode} ${c.cardNumber}`;
      const imgUrl = c.imageUrl || "";
      li.innerHTML = `
        ${productThumbHtml(imgUrl, title, title)}
        <div class="pk-special-order__card-meta">
          <strong>${escapeHtml(title)}</strong>
          <p>${escapeHtml(c.setCode)} · #${escapeHtml(c.cardNumber)}${c.rarity ? " · " + escapeHtml(c.rarity) : ""}</p>
          <button type="button" class="btn btn--primary-red btn--sm" data-confirm-card>C'est celle-ci</button>
        </div>
      `;
      li.querySelector("[data-confirm-card]")?.addEventListener("click", () => confirmCard(c));
      ul.appendChild(li);
    });
    bindZoomTriggers(ul);
  }

  async function confirmCard(card) {
    selectedCardRef = {
      setCode: card.setCode,
      cardNumber: card.cardNumber,
      titleJP: card.titleJP,
      titleFR: card.titleFR,
      imageUrl: card.imageUrl,
      rarity: card.rarity,
      language: card.language,
    };
    showError("");
    try {
      const data = await api("/confirm", {
        method: "POST",
        body: JSON.stringify({ requestId, cardRef: selectedCardRef }),
      });
      allOffers = data.offers || [];
      activeGradeFilter = "ALL";
      renderGradeFilters();
      renderOffers(getFilteredOffers(), data.noOffers);
      showStep("offers");
    } catch (err) {
      showError(err.message);
    }
  }

  /** Affiche uniquement le grade FR (sans texte japonais ni doublon). */
  function formatOfferCondition(raw) {
    if (!raw) return "—";
    let c = String(raw).split("(")[0].trim();
    const psa = c.match(/PSA\s*\d+/i);
    if (psa) return psa[0].toUpperCase().replace(/\s+/g, "");
    const parts = c.split("—").map((s) => s.trim()).filter(Boolean);
    const grade = parts[0] || parts[parts.length - 1] || c;
    if (/^[A-D]$/i.test(grade)) return `Grade ${grade.toUpperCase()}`;
    return grade;
  }

  /** Clé de filtre alignée sur Snkrdunk (PSA10, A, B…). */
  function parseGradeFilterKey(offer) {
    const g = String(offer?.conditionGrade || "").trim().toUpperCase();
    if (g) {
      if (/^PSA\d+/.test(g)) return g.replace(/\s+/g, "");
      if (/^[A-D]$/.test(g)) return g;
      if (/^ARS\d+/.test(g)) return g;
      if (/^BGS/.test(g)) return g;
      if (g === "新品") return "新品";
      return g;
    }
    const label = formatOfferCondition(offer?.condition);
    if (/^Grade ([A-D])$/i.test(label)) return label.replace(/^Grade /i, "").toUpperCase();
    if (/^PSA\d+/i.test(label)) return label.toUpperCase();
    if (/^ARS\d+/i.test(label)) return label.toUpperCase();
    if (/^BGS/i.test(label)) return label.toUpperCase();
    return "OTHER";
  }

  function gradeFilterLabel(key) {
    return GRADE_FILTER_LABELS[key] || key;
  }

  function getFilteredOffers() {
    if (activeGradeFilter === "ALL") return allOffers;
    return allOffers.filter((o) => parseGradeFilterKey(o) === activeGradeFilter);
  }

  function renderGradeFilters() {
    const wrap = $("[data-grade-filters]");
    const inner = $("[data-grade-filters-inner]");
    const emptyMsg = $("[data-grade-filter-empty]");
    if (!wrap || !inner) return;

    if (!allOffers.length) {
      wrap.hidden = true;
      return;
    }

    const counts = new Map();
    allOffers.forEach((o) => {
      const k = parseGradeFilterKey(o);
      counts.set(k, (counts.get(k) || 0) + 1);
    });

    const keys = ["ALL"];
    for (const k of GRADE_FILTER_ORDER) {
      if (k === "ALL") continue;
      if (counts.has(k)) keys.push(k);
    }
    for (const k of counts.keys()) {
      if (!keys.includes(k)) keys.push(k);
    }

    if (!keys.includes(activeGradeFilter)) activeGradeFilter = "ALL";

    inner.innerHTML = keys
      .map((key) => {
        const n = key === "ALL" ? allOffers.length : counts.get(key) || 0;
        const active = key === activeGradeFilter ? " is-active" : "";
        const tabSelected = active ? ' aria-selected="true"' : ' aria-selected="false"';
        return `<button type="button" class="pk-grade-filter${active}" data-grade-filter="${escapeHtml(key)}" role="tab"${tabSelected}>
          <span class="pk-grade-filter__label">${escapeHtml(gradeFilterLabel(key))}</span>
          <span class="pk-grade-filter__count">${n}</span>
        </button>`;
      })
      .join("");

    wrap.hidden = false;

    inner.querySelectorAll("[data-grade-filter]").forEach((btn) => {
      btn.addEventListener("click", () => {
        activeGradeFilter = btn.getAttribute("data-grade-filter") || "ALL";
        renderGradeFilters();
        renderOffers(getFilteredOffers(), false);
        if (emptyMsg) {
          emptyMsg.hidden = getFilteredOffers().length > 0;
        }
      });
    });
  }

  function renderOffers(offers, noOffers) {
    const ul = $("[data-offers-list]");
    const manual = $("[data-no-offers]");
    if (!ul) return;
    ul.innerHTML = "";
    const emptyFilter = $("[data-grade-filter-empty]");
    if (noOffers || !allOffers.length) {
      if (manual) manual.hidden = false;
      if (emptyFilter) emptyFilter.hidden = true;
      return;
    }
    if (manual) manual.hidden = true;
    if (!offers.length) {
      if (emptyFilter) emptyFilter.hidden = false;
      return;
    }
    if (emptyFilter) emptyFilter.hidden = true;

    const fallbackImg = selectedCardRef?.imageUrl || "";
    const cardTitle =
      selectedCardRef?.titleFR ||
      selectedCardRef?.titleJP ||
      (selectedCardRef?.setCode
        ? `${selectedCardRef.setCode} #${selectedCardRef.cardNumber}`
        : "Carte");

    offers.forEach((o) => {
      const li = document.createElement("li");
      li.className = "pk-special-order__offer";
      li.dataset.offerId = String(o.id);
      const price = parseFloat(o.finalPriceEUR || 0).toFixed(2);
      const conditionLabel = formatOfferCondition(o.condition);
      const images = normalizeImageUrls(o, fallbackImg);
      const zoomTitle = `${cardTitle} — ${conditionLabel}`;
      li.innerHTML = `
        ${offerPhotosHtml(images, zoomTitle)}
        <div class="pk-special-order__offer-body">
          <p>État : <strong>${escapeHtml(conditionLabel)}</strong></p>
          <p class="pk-special-order__offer-final"><strong>${price} €</strong></p>
          <button type="button" class="btn btn--primary-red" data-checkout-offer>Commander cette offre</button>
        </div>
      `;
      li.addEventListener("click", (e) => {
        if (e.target.closest("button")) return;
        ul.querySelectorAll(".pk-special-order__offer").forEach((el) =>
          el.classList.remove("is-selected"),
        );
        li.classList.add("is-selected");
        li.scrollIntoView({ behavior: "smooth", block: "nearest" });
      });
      li.querySelector("[data-checkout-offer]")?.addEventListener("click", (e) => {
        e.stopPropagation();
        checkout(o.id);
      });
      bindOfferPhotoControls(li);
      ul.appendChild(li);
    });
    if (offers.length === 1) {
      ul.querySelector(".pk-special-order__offer")?.classList.add("is-selected");
    }
    bindZoomTriggers(ul);
  }

  async function checkout(offerId) {
    const email =
      window.Shopify?.customer?.email ||
      prompt("Votre email pour la commande :") ||
      undefined;
    showError("");
    try {
      const data = await api("/checkout", {
        method: "POST",
        body: JSON.stringify({ requestId, offerId, customerEmail: email }),
      });
      const link = $("[data-checkout-link]");
      const msg = $("[data-checkout-msg]");
      if (link) {
        link.href = data.checkoutUrl || "#";
        link.hidden = !data.checkoutUrl;
      }
      if (msg) {
        msg.textContent =
          "Vous allez être redirigé vers le paiement sécurisé Shopify pour finaliser votre commande spéciale.";
      }
      showStep("checkout");
      if (data.checkoutUrl) window.open(data.checkoutUrl, "_blank");
    } catch (err) {
      showError(err.message);
    }
  }

  $("[data-show-not-found-form]")?.addEventListener("click", () => {
    setNotFoundFormVisible(true, "no_match");
  });

  $("[data-hide-not-found-form]")?.addEventListener("click", () => {
    setNotFoundFormVisible(false);
  });

  notFoundForm?.querySelectorAll('[name="nfProductType"]').forEach((el) => {
    el.addEventListener("change", syncNotFoundGradeField);
  });

  const nfImageInput = notFoundForm?.querySelector("[data-nf-image-input]");
  nfImageInput?.addEventListener("change", () => {
    const file = nfImageInput.files?.[0];
    if (file && file.size > 4 * 1024 * 1024) {
      showError("Image trop volumineuse (max 4 Mo).");
      nfImageInput.value = "";
      updateNotFoundFileLabel(null);
      return;
    }
    showError("");
    updateNotFoundFileLabel(file || null);
  });

  $("[data-nf-file-trigger]")?.addEventListener("click", (e) => {
    e.preventDefault();
    nfImageInput?.click();
  });

  notFoundForm?.addEventListener("submit", async (e) => {
    e.preventDefault();
    showError("");

    const setCode = String(
      notFoundForm.querySelector('[name="nfSetCode"]')?.value || "",
    ).trim();
    const cardNumber = String(
      notFoundForm.querySelector('[name="nfCardNumber"]')?.value || "",
    ).trim();
    const customerEmail = String(
      notFoundForm.querySelector('[name="nfCustomerEmail"]')?.value || "",
    ).trim();
    const customerName = String(
      notFoundForm.querySelector('[name="nfCustomerName"]')?.value || "",
    ).trim();
    const productType =
      notFoundForm.querySelector('[name="nfProductType"]:checked')?.value || "";
    const imageFile = nfImageInput?.files?.[0];

    if (!setCode || !cardNumber) {
      showError("Indiquez le code série et le numéro de carte.");
      return;
    }
    if (!customerEmail) {
      showError("Indiquez votre adresse email.");
      return;
    }
    if (!customerName) {
      showError("Indiquez votre nom.");
      return;
    }
    if (!productType) {
      showError("Choisissez le type de produit recherché.");
      return;
    }
    if (!imageFile) {
      showError("Ajoutez une photo de la carte recherchée.");
      return;
    }
    if (imageFile.size > 4 * 1024 * 1024) {
      showError("Image trop volumineuse (max 4 Mo).");
      return;
    }

    const payload = {
      setCode,
      cardNumber,
      title: String(notFoundForm.querySelector('[name="nfTitle"]')?.value || "").trim() || undefined,
      language: notFoundForm.querySelector('[name="nfLanguage"]')?.value || "JP",
      customerEmail,
      customerName,
      productType,
      urgency: notFoundForm.querySelector('[name="nfUrgency"]:checked')?.value || "normal",
      notFoundReason: notFoundForm.querySelector("[data-nf-reason]")?.value || "no_match",
    };
    if (requestId) payload.requestId = requestId;

    const desiredGrade = String(
      notFoundForm.querySelector('[name="nfDesiredGrade"]')?.value || "",
    ).trim();
    if (desiredGrade) payload.desiredGrade = desiredGrade;

    const maxBudget = String(
      notFoundForm.querySelector('[name="nfMaxBudget"]')?.value || "",
    ).trim();
    if (maxBudget) payload.maxBudgetEur = Number(maxBudget);

    const notes = String(
      notFoundForm.querySelector('[name="nfNotes"]')?.value || "",
    ).trim();
    if (notes) payload.notes = notes;

    const submitBtn = notFoundForm.querySelector("[data-not-found-submit]");
    if (submitBtn) submitBtn.disabled = true;
    try {
      const compressed = await compressImageForUpload(imageFile);
      const { base64, mime } = await readImageAsBase64(compressed);
      payload.customerImageBase64 = base64;
      payload.customerImageMime = mime;

      const data = await api("/manual-request", {
        method: "POST",
        body: JSON.stringify(payload),
      });
      showNotFoundSuccess(
        data.message ||
          "Demande enregistrée. Notre équipe vous recontactera par email.",
      );
      notFoundForm.reset();
      updateNotFoundFileLabel(null);
    } catch (err) {
      showError(err.message);
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  });

  $("[data-manual-request]")?.addEventListener("click", () => {
    showStep("candidates");
    setNotFoundFormVisible(true, "no_offers");
    prefillNotFoundForm("no_offers");
  });

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  updateStepper("search");
  initLightbox();
  init();
})();
